<template>
    <div class="how-to-play">
        <LoadingCommon v-if="isLoadingScreen" />
        <template v-else>
            <Title  />
            <Content :length="listNumber.length"/>
            <Games :listNumber="listNumber" />
        </template>
    </div>
</template>
<script>
import gamesService from '@/services/games.service'
import Title from '@/components/how-to-play/title/index.vue'
import Content from '@/components/how-to-play/content/index.vue'
import Games from '@/components/how-to-play/game/index.vue'
import LoadingCommon from '@/components/common/loading.vue'
const IS_DEV = process.env.VUE_APP_DEV

export default {
    components: { LoadingCommon, Title, Content, Games },
    data() {
        return {
            listNumber: [],
            isLoadingScreen: true,
        }
    },
    created() {
        this.fetchData()
    },
    methods: {
        async fetchData() {
            try {
                const resp = await gamesService.getListGames()

                this.listNumber = resp.data
                this.isLoadingScreen = false
            } catch (error) {
                if (parseInt(IS_DEV)) {
                    console.log(error)
                }
            }
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/how-to-play/index.scss';
</style>
